import React from "react";
import { Icons } from "../../components/common/Icons";
import { sidebarItems } from "../../data/internData";
import { useInternData } from "../../context/InternContext";
import { AvatarDisplay } from "../../components/common/AvatarUpload";
import { usePermissions } from "../../hooks/usePermissions";import "../../assets/styles/Intern/InternSidebar.css";

function InternSidebar({ active, setActive, onLogout, user, sidebarOpen, setSidebarOpen }) {
  const { internData, notifications } = useInternData();
  const notifUnread = (notifications || []).filter((n) => n.unread || !n.is_read).length;
  const chatUnread = (notifications || []).filter((n) => (n.unread || !n.is_read) && String(n.type || '').toLowerCase() === 'chat').length;
  const { canShowNav } = usePermissions();
  const visibleItems = sidebarItems.filter((item) => canShowNav(item.key));
  return (
    <div
      className={`sidebar ${sidebarOpen ? "sidebar-open" : "sidebar-closed"}`}
      onMouseEnter={() => setSidebarOpen?.(true)}
      onMouseLeave={() => setSidebarOpen?.(false)}
    >
      <div className="sidebar-brand">
        <img src="/logo.png" alt="AMS" className="sidebar-logo internsidebar-inline-1" />
        <div><div className="sidebar-brand-text">AMSHRMS</div><div className="sidebar-brand-sub">Intern Portal</div></div>
      </div>
      <nav className="sidebar-nav">
        <div className="sidebar-section-label">Main Menu</div>
        {visibleItems.map((item) =>
        <div key={item.key} className={`sidebar-item ${active === item.key ? "active" : ""}`} onClick={() => setActive(item.key)}>
            <item.icon />{item.label}
            {item.key === "announcements" && notifUnread > 0 && <span className="sidebar-badge">{notifUnread > 99 ? "99+" : notifUnread}</span>}
            {item.key === "chat" && chatUnread > 0 && <span className="sidebar-badge">{chatUnread > 99 ? "99+" : chatUnread}</span>}
          </div>
        )}
      </nav>
      <div className="sidebar-footer">
        <div className="sidebar-user">
          <AvatarDisplay src={user?.avatar} name={internData.name || user?.name} size={36} />
          <div>
            <div className="sidebar-user-name">{internData.name || user?.name || "Intern"}</div>
            <div className="sidebar-user-role">{internData.role || "Intern"}</div>
          </div>
        </div>
        <button onClick={onLogout} className="internsidebar-inline-2">
          <Icons.Logout /> Sign Out
        </button>
      </div>
    </div>);

}

export default InternSidebar;
